import keyMirror from 'keymirror';

import type { SectionIcons } from '@/admin/components/sideBar/types';

export const sidebarActionTypes = keyMirror({
	SET_EXPANDED_MENU: null,
	SET_SETTINGS_MENU: null,
});

export const sectionIcons: SectionIcons = {
	subjects: 'icon-grid',
	topics: 'icon-bookshelf',
	'study-go-bridge': 'icon-grid',
};
